import { Globe } from "lucide-react";
import { useI18n } from "@/i18n";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export default function LanguageSelector({ variant = "dark" }) {
  const { lang, setLang, languages } = useI18n();
  const cls =
    variant === "dark"
      ? "h-9 w-[130px] gap-2 border-white/15 bg-white/5 text-sm text-white"
      : "h-9 w-[130px] gap-2 border-slate-300 bg-white text-sm text-slate-900";
  return (
    <Select value={lang} onValueChange={setLang}>
      <SelectTrigger data-testid="language-selector" className={cls}>
        <Globe className="h-4 w-4 opacity-70" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {languages.map((l) => (
          <SelectItem key={l.code} value={l.code} data-testid={`lang-option-${l.code}`}>
            {l.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
